import React from "react";
import RealtimeRentationContext from "../../realtimeUsers/component/RealtimeRentationContext";
import TrendChartCo from "@/pages/dashboard/components/TrendChartCo";
import './index.scss';

const RealtimeOverviewTrendContent = (props: any) => {
  const { radioValue, currentSegment } = props || {};

  return radioValue === 'all' ?
    <RealtimeRentationContext {...props} config={currentSegment?.allConfig || {}} />
    : <TrendChartCo {...props} config={currentSegment?.diminsionConfig || {}} />;
};


export default RealtimeOverviewTrendContent;